import Vue from 'vue';

export class Ibutton {

    static create(){
        let street = {};
        street.serial = null;
        street.id_parceiro = null;
        return street;
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static remove(id){
        return new Promise((ok, fail) => {
            Vue.http.delete('ibutton/' + id)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_chip
     * @return {Promise}
     */
    static byPK(id_chip){
        return new Promise((ok, fail) => {
            Vue.http.get('ibutton/'+ id_chip)
                .then((res) =>  ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static save(json){
        return new Promise((ok, fail) => {

            let promisse = null;

            if(json.id_ibutton){
                promisse = Vue.http.put('ibutton/'+ json.id_ibutton, json);
            } else {
                promisse = Vue.http.post('ibutton', json);
            }

            promisse
                .then((res) => ok(res.data))
                .catch((err) => fail(err));

        });
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static saveAll(json){
        return new Promise((ok, fail) => {
            let promisse = Vue.http.post('ibutton/all', json);

            promisse
                .then((res) => ok(res.data))
                .catch((err) => fail(err));

        });
    }

    /**
     *
     * @return {Promise}
     */
    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/ibuttons')
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

}
